/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { Button } from '@frontend/components';

import { useCompleteOrder } from '../../data/hooks';
import { getCanSubmit, getIsCreatingOrder } from '../../data/reducer';

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 0px;
  padding-left: 22px;
  padding-right: 22px;
  padding-top: 0px;
`;

const ShippingAndPaymentFooter = () => {
  const canSubmit = useSelector(getCanSubmit);
  const isCreatingOrder = useSelector(getIsCreatingOrder);
  const completeOrder = useCompleteOrder();

  const complete = useCallback(() => {
    completeOrder();
  }, [completeOrder]);

  return (
    <Footer>
      <>&nbsp;</>
      <Button
        variant="primary"
        isDisabled={!canSubmit || isCreatingOrder}
        isLoading={isCreatingOrder}
        onClick={complete}
      >
        COMPLETE ORDER
      </Button>
    </Footer>
  );
};

export default ShippingAndPaymentFooter;
